/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMathMax = createReactComponent("math-max", "IconMathMax", [
  ["path", { d: "M12 5m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0", key: "svg-0" }],
  [
    "path",
    { d: "M3 20c0 -8.75 4 -14 7 -14.5m4 0c3 .5 7 5.75 7 14.5", key: "svg-1" }
  ]
]);

export { IconMathMax as default };
//# sourceMappingURL=IconMathMax.js.map
